import BaseService from "services/BaseService";
import _ from "lodash";

class LoginServices extends BaseService {
    me = async () => {
        var data = await this._api.post("master/account/me",);
        return data;
    }

  



}
export default LoginServices;
